import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import SoftBox from 'components/SoftBox';
import SoftButton from 'components/SoftButton';
import SoftSelect from 'components/SoftSelect';
import SoftInput from 'components/SoftInput';
import Grid from '@mui/material/Grid';
import SoftDatePicker from 'components/SoftDatePicker';
import SoftTypography from 'components/SoftTypography';

function ModalFiltroConsolidado({ show, handleClose, onApplyFilters }) {
    const [filters, setFilters] = useState({
        consolidado: "",
        fechaDesde: null,
        fechaHasta: null,
        transport: null
    });

    const transportOptions = [
        { value: 'aereo', label: 'Aéreo' },
        { value: 'maritimo', label: 'Marítimo' }
    ];

    const handleApply = () => {
        onApplyFilters(filters);
        handleClose();
    };

    const handleReset = () => {
        setFilters({
            consolidado: "",
            fechaDesde: null,
            fechaHasta: null,
            transport: null
        });
    };

    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="lg"
            aria-labelledby="modal-filtro-consolidado"
            centered
            backdrop="static"
            className="modal-container small"
            style={{ zIndex: 1050 }}
        >
            <Modal.Header closeButton>
                <Modal.Title>Filtrar Consolidado</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <SoftBox mt={2}>
                    <Grid container spacing={3}>
                        {/* Campo de Texto: # Consolidado usando SoftInput */}
                        <Grid item xs={12} md={6}>
                            <SoftBox display="flex" flexDirection="column" gap={1}>
                                <SoftTypography variant="caption" fontWeight="bold" color="text">
                                    # Consolidado
                                </SoftTypography>
                                <SoftInput
                                    value={filters.consolidado}
                                    onChange={(e) =>
                                        setFilters({ ...filters, consolidado: e.target.value })
                                    }
                                    placeholder="Ingresa un numero de consolidado"
                                />
                            </SoftBox>
                        </Grid>

                        {/* Select: Transporte */}
                        <Grid item xs={12} md={6}>
                            <SoftBox display="flex" flexDirection="column" gap={1}>
                                <SoftTypography variant="caption" fontWeight="bold" color="text">
                                    Transporte
                                </SoftTypography>
                                <SoftSelect
                                    options={transportOptions}
                                    value={filters.transport}
                                    onChange={(selected) =>
                                        setFilters({ ...filters, transport: selected })
                                    }
                                    placeholder="Selecciona el tipo de transporte..."
                                    isClearable={false}
                                />
                            </SoftBox>
                        </Grid>

                        {/* Fecha Desde */}
                        <Grid item xs={12} md={6}>
                            <SoftBox display="flex" flexDirection="column" gap={1}>
                                <SoftTypography variant="caption" fontWeight="bold" color="text">
                                    Fecha Desde
                                </SoftTypography>
                                <SoftDatePicker
                                    placeholder="Selecciona la fecha de inicio."
                                    value={filters.fechaDesde}
                                    onChange={(date) =>
                                        setFilters({ ...filters, fechaDesde: date[0] })
                                    }
                                    options={{
                                        dateFormat: "Y-m-d",
                                        altInput: true,
                                        altFormat: "F j, Y"
                                    }}
                                />
                            </SoftBox>
                        </Grid>

                        {/* Fecha Hasta */}
                        <Grid item xs={12} md={6}>
                            <SoftBox display="flex" flexDirection="column" gap={1}>
                                <SoftTypography variant="caption" fontWeight="bold" color="text">
                                    Fecha Hasta
                                </SoftTypography>
                                <SoftDatePicker
                                    placeholder="Selecciona la fecha de termino."
                                    value={filters.fechaHasta}
                                    onChange={(date) =>
                                        setFilters({ ...filters, fechaHasta: date[0] })
                                    }
                                    options={{
                                        dateFormat: "Y-m-d",
                                        altInput: true,
                                        altFormat: "F j, Y"
                                    }}
                                />
                            </SoftBox>
                        </Grid>
                    </Grid>
                </SoftBox>
            </Modal.Body>
            <Modal.Footer>
                <SoftButton
                    variant="gradient"
                    color="secondary"
                    onClick={handleReset}
                    sx={{ mr: 2 }}
                >
                    Limpiar
                </SoftButton>
                <SoftButton
                    variant="gradient"
                    color="success"
                    onClick={handleApply}
                    sx={{ mr: 2 }}
                >
                    Aplicar Filtros
                </SoftButton>
                <SoftButton variant="gradient" color="error" onClick={handleClose}>
                    Cancelar
                </SoftButton>
            </Modal.Footer>
        </Modal>
    );
}

ModalFiltroConsolidado.propTypes = {
    show: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    onApplyFilters: PropTypes.func.isRequired
};

export default ModalFiltroConsolidado;
